import { uiLanguageOf } from "@/lib/site/site-routing";
import type { SiteLanguageInfo, SiteLanguageOption } from "@/templates/site/types";

export type LanguageSuggestion = { site: SiteLanguageOption; reason: "preferred" | "browser" };

export function suggestedLanguageSite(
  language: SiteLanguageInfo,
  preferredCode: string | null,
  browserLanguages: readonly string[],
): LanguageSuggestion | null {
  const preferred = language.sites.find((site) => site.code === preferredCode);
  if (preferred) return preferred.current ? null : { site: preferred, reason: "preferred" };

  for (const tag of browserLanguages.filter(Boolean).map((value) => value.toLowerCase())) {
    const site = language.sites.find((item) => item.locale.toLowerCase() === tag)
      ?? language.sites.find((item) => uiLanguageOf(item.locale) === uiLanguageOf(tag));
    if (site) return site.current ? null : { site, reason: "browser" };
  }
  return null;
}
